"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _react = require("react");

var _context = _interopRequireDefault(require("./context"));

/**
 * ```js
 * const {
 *   // Auth state:
 *   error,
 *   isAuthenticated,
 *   isLoading,
 *   token,
 *   user,
 *   // Auth methods:
 *   getTokenSilently,
 *   getUserProfile,
 *   loginWithRedirect,
 *   logout,
 * } = useAuth();
 * ```
 *
 * Use the `useAuth` hook in components to access the auth state and methods.
 *
 */
var useAuth = function useAuth() {
  return (0, _react.useContext)(_context.default);
};

var _default = useAuth;
exports.default = _default;